import React, {useEffect, useState} from "react";
import {Box, Divider, Grid, Typography} from '@mui/material';
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DossierService from "../../services/DossierService";
import {dateFormate} from "../../utils/utils";

const baseUrl = window?.Liferay ? window?.Liferay?.ThemeDisplay.getPortalURL() : "https://lab.diginfactory.com";

const ViewSectionComponent = ({ section }) => {
    const secDossier = new DossierService();
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);

    console.log("La se section", section.id);

    const fetchData = async (id) => {
        const response = await secDossier.allSectionDossier(id);
        setSections(response);
        console.log(response);
    }

    useEffect(() => {
        fetchData(section.id).then(() => setLoading(false));
    }, []);

    function showSection(item) {
        const typeKey = item?.r_attributSection_c_attribut?.type?.key;
        const nom = item?.r_attributSection_c_attribut?.nom;
        const value = item?.value;

        switch (typeKey) {
            case "enum":
                return (
                    <>
                        <Grid container alignItems="center" justifyContent="space-between" spacing={2} mb={1} mt={2}>
                            <Grid item>{nom}</Grid>
                            <Grid item>
                                <Typography fontWeight="bold">
                                    {/*{value ? JSON.parse(value).name : "N/A"}*/}
                                    {value ?? "N/A"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider />
                    </>
                );

            case "date":
                return (
                    <>
                        <Grid container alignItems="center" justifyContent="space-between" spacing={2} mb={1} mt={2}>
                            <Grid item>{nom}</Grid>
                            <Grid item>
                                <Typography fontWeight="bold">
                                    {value ? dateFormate(value) : "N/A"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider />
                    </>
                );

            case "fichier":
                return (
                    <>
                        <Box
                            sx={{ backgroundColor: '#F6F6F699', px: 2, py: 1, borderRadius: 2, cursor: "pointer" }}
                            mt={4} onClick={() => {
                                const url = baseUrl + value.split("&")[0];
                                window.open(
                                    url,
                                    'Document',
                                    'height=600,width=800,left=200,top=200,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes'
                                );

                            }}

                        >
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item><InsertDriveFileOutlinedIcon /> {nom}</Grid>
                                <Grid item><VisibilityOutlinedIcon /></Grid>
                            </Grid>
                        </Box>
                    </>
                );

            case "entier":
                return (
                    <>
                        <Grid container alignItems="center" justifyContent="space-between" spacing={2} mb={1} mt={2}>
                            <Grid item>{nom}</Grid>
                            <Grid item>
                                <Typography fontWeight="bold">
                                    {value ?? "N/A"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider />
                    </>
                );

            default:
                return (
                    <>
                        <Grid container alignItems="center" justifyContent="space-between" spacing={2} mb={1} mt={2}>
                            <Grid item>{nom}</Grid>
                            <Grid item>
                                <Typography fontWeight="bold">
                                    {value ?? "N/A"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider />
                    </>
                );
        }
    }

    return (
        <>
            <Box sx={{ flex: 1 }}>
                <Box sx={{ mb: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: '500' }} color="primary" gutterBottom>
                        {section?.r_sectionStatusDossier_c_sectione?.libelle || 'Section sans titre'}
                    </Typography>
                    <Divider />

                    {
                        loading ? (<p>Loading...</p>) :
                        sections.map((item) => showSection(item))
                    }

                </Box>
            </Box>
        </>
    );
}
export default ViewSectionComponent;